// src/components/QuestionDetailCard.js
import React, { useEffect, useState } from "react";
import { Tag } from "@carbon/react";
import useMediaQuery from "../components/useMediaQuery";
import AIInterviewTable from "../components/AIInterviewTable";
import LabelCheckboxGroup from "../components/LabelCheckboxGroup";
import { QUESTION_LABELS, LABEL_ORDER } from "../components/aiInterviewUtils";
import api from "../api";
import "../pages/AiInterviewQuestions.css";
import { useAuth } from "../auth/AuthContext";

export default function QuestionDetailCard() {
  const [rows, setRows] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([...LABEL_ORDER]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const isNarrow = useMediaQuery("(max-width: 1024px)");

  const { user } = useAuth() || {};

  const storedPatient = sessionStorage.getItem("patient");
  const patient = storedPatient ? JSON.parse(storedPatient) : null;
  const research_id = patient?.research_id || user?.id || "P010";

  useEffect(() => {
    const fetchLatestAiDialog = async () => {
      try {
        setLoading(true);

        // === 最新の日付を sessionStorage から取得（Summaryから保存済みの想定） ===
        const storedDates = JSON.parse(sessionStorage.getItem("aiDates") ?? "[]");
        if (!storedDates.length) {
          setError("日付データがありません。");
          setLoading(false);
          return;
        }

        // 最新の日付のみ（降順前提）
        const latestDate = storedDates.sort((a, b) => new Date(b) - new Date(a))[0];

        // === API 呼び出し ===
        const res = await api.post("/v1/doctor/ai_dialog", {
          research_id,
          category_list: Object.keys(QUESTION_LABELS),
          request_date_list: [latestDate],
        });

        const data = res.data ?? {};
        const {
          answer_date_list = [],
          question_list = [],
          answer_list = [],
          regenerate_list = [],
          subid_list = [],
        } = data;

        // === データ整形 ===
        const rows = question_list.map((q, i) => {
          const categoryId = Object.keys(QUESTION_LABELS)[i % Object.keys(QUESTION_LABELS).length]; // 仮対応
          return {
            date: answer_date_list[i] ?? latestDate,
            label: QUESTION_LABELS[categoryId] ?? categoryId,
            category: categoryId,
            question: q,
            baseQuestion: `subid:${subid_list[i] ?? ""}`,
            score: answer_list[i] ?? "",
            regenerateCount: regenerate_list[i] ?? 0,
          };
        });

        setRows(rows);
      } catch (err) {
        console.error("ai_dialog取得エラー:", err);
        setError("AI問診データの取得に失敗しました。");
      } finally {
        setLoading(false);
      }
    };

    fetchLatestAiDialog();
  }, []);

  const filtered = rows.filter((r) => selectedLabels.includes(r.label));

  return (
    <div style={{ padding: "1rem", margin: "0 auto", width: "100%" }}>
      {loading && <p style={{ textAlign: "center" }}>読み込み中...</p>}
      {error && (
        <p style={{ color: "red", textAlign: "center" }}>{error}</p>
      )}

      {!loading && !error && (
        <>
          <div className="check-wrap" style={{ marginBottom: "1rem" }}>
            <LabelCheckboxGroup
              allLabels={LABEL_ORDER}
              selectedLabels={selectedLabels}
              onToggle={(label) =>
                setSelectedLabels((prev) =>
                  prev.includes(label)
                    ? prev.filter((l) => l !== label)
                    : [...prev, label]
                )
              }
              idPrefix="latest"
            />
          </div>

          <AIInterviewTable
            rows={filtered}
            latestOnly
            showRegenCount
            showBaseQuestion={false}
            expandable
            isNarrow={isNarrow}
          />
        </>
      )}
    </div>
  );
}
